import axiosClient from '@/api/axiosClient';
import { API_UPLOAD } from '@/config/paths/API_PATH';

async function upload(formData, onUploadProgress, uploadUrl = API_UPLOAD) {
  const res = await axiosClient.post(
    // API_UPLOAD,
    uploadUrl,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
    onUploadProgress
  );

  return res;
}

export default upload;
